
import "./PrivateEvents.css";
import weddingImg from "../assets/wedding.jpg";
import corporateImg from "../assets/corporate.webp";
import listeningPartyImg from "../assets/listening-party.jpeg";     
import birthdayImg from "../assets/birthday.jpg";
import privateDiningImg from "../assets/dining.webp";   


function PrivateEventsPage() {

  return (
    <div className="private-events-page page-container">
      {/* Introductory Section */}
      <section className="intro-text">
        <h1>Private Events at LKO</h1>
        <p>
          Make your celebrations unforgettable with Lasgidi Restaurant. From
          corporate gatherings to intimate parties or a grand celebration, we
          have the ideal setting for you. Let us make your event unforgettable.
          <br />
          <br />
          Get in touch today, and let’s start planning together.
        </p>
        <a
          className="cta-button primary-btn inquire-button post-review-btn"
          href="tel:01615660344"
        >
          INQUIRE NOW
        </a>
      </section>

      <section class="event-offerings">
        <div class="offerings-list">
          <div class="offering">
            <img
              src={weddingImg}
              alt="Wedding Reception"
              class="offering-image"
            />
            <h3>Wedding Receptions</h3>
            <p>
              Celebrate your special day with elegant decor, tailored menus, and
              an atmosphere designed for memories.
            </p>
          </div>
          <div class="offering">
            <img
              src={corporateImg}
              alt="Corporate Function"
              class="offering-image"
            />
            <h3>Corporate Functions</h3>
            <p>
              Host your next corporate event with us, complete with custom
              setups and a seamless experience from start to finish.
            </p>
          </div>
          <div class="offering">
            <img
              src={listeningPartyImg}
              alt="Listening Party"
              class="offering-image"
            />
            <h3>Listening Parties</h3>
            <p>
              Enjoy an intimate setting with acoustics and ambiance perfect for
              album releases and private listening sessions.
            </p>
          </div>
          <div class="offering">
            <img
              src={birthdayImg}
              alt="Birthday Celebration"
              class="offering-image"
            />
            <h3>Birthday Celebrations</h3>
            <p>
              Make birthdays memorable with customized themes, vibrant decor,
              and a space filled with fun and excitement.
            </p>
          </div>
          <div class="offering">
            <img
              src={privateDiningImg}
              alt="Private Dining"
              class="offering-image"
            />
            <h3>Private Dining</h3>
            <p>
              Enjoy an exclusive dining experience in a cozy setting, perfect
              for small gatherings with a personalized menu.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivateEventsPage;
